var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281.719,
    height: 63.873,
    viewBox: "0 0 281.719 63.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Blue",
    transform: "translate(-41.011 -18.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5339",
    "data-name": "Group 5339",
    transform: "translate(9232.748 18641.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M188.119,189.193l-4.754,2.836c-.331-.253-.2-.536-.2-.777V169.772a1.11,1.11,0,0,1,.579-1.181q15.078-8.663,30.13-17.375a1.717,1.717,0,0,1,.369-.116c0,.338.019.676.031,1.014,0,.808-.045,1.616,0,2.42a17.884,17.884,0,0,0,.189,4.234,1.58,1.58,0,0,0-.888.364q-7.448,4.268-14.87,8.549c-2.854,1.64-5.723,3.261-8.587,4.889-.423-.343-.73-.095-.728.3a1.058,1.058,0,0,0,.395,1.033c.111,4.187.078,8.377.017,12.564-.087.09-.236.177-.253.269a1.5,1.5,0,0,1-1.165,1.581C187.843,188.451,188.067,188.857,188.119,189.193Z",
    transform: "translate(-9374.875 -18774.855)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M230.047,315.527q0,3.811-.024,7.62c-2.16-1.007-4.154-2.313-6.219-3.49-5.7-3.251-11.368-6.557-17.072-9.8a1.93,1.93,0,0,1-1.134-1.983c.076-3.4.031-6.8.031-10.2,0-1.224,0-1.222-1.1-.6-.2.109-.406.2-.61.293-.057-.336-.276-.742.253-.881a1.5,1.5,0,0,0,1.165-1.581c0-.092.165-.18.253-.269.017.357.05.709.045,1.07,0,.473.095.695.6.392,1.786-1.063,3.58-2.115,5.369-3.171.491-.262.766-.34.756.44-.038,3.66,0,7.325-.035,10.983a1.44,1.44,0,0,0,.825,1.46C218.792,309.029,224.423,312.283,230.047,315.527Z",
    transform: "translate(-9390.673 -18883.031)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(-9191.737 -18623.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M188.119,189.193l-4.754,2.836c-.331-.253-.2-.536-.2-.777V169.772a1.11,1.11,0,0,1,.579-1.181q15.078-8.663,30.13-17.375a1.717,1.717,0,0,1,.369-.116c0,.338.019.676.031,1.014,0,.808-.045,1.616,0,2.42a17.884,17.884,0,0,0,.189,4.234,1.58,1.58,0,0,0-.888.364q-7.448,4.268-14.87,8.549c-2.854,1.64-5.723,3.261-8.587,4.889-.423-.343-.73-.095-.728.3a1.058,1.058,0,0,0,.395,1.033c.111,4.187.078,8.377.017,12.564-.087.09-.236.177-.253.269a1.5,1.5,0,0,1-1.165,1.581C187.843,188.451,188.067,188.857,188.119,189.193Z",
    transform: "translate(-183.138 -151.1)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M210.278,241.455c-.432.362-.189.893-.333,1.328a1.067,1.067,0,0,1-.395-1.033C209.548,241.351,209.855,241.1,210.278,241.455Z",
    transform: "translate(-203.309 -219.976)",
    fill: "#50b5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(-9191.737 -18623.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M230.047,315.527q0,3.811-.024,7.62c-2.16-1.007-4.154-2.313-6.219-3.49-5.7-3.251-11.368-6.557-17.072-9.8a1.93,1.93,0,0,1-1.134-1.983c.076-3.4.031-6.8.031-10.2,0-1.224,0-1.222-1.1-.6-.2.109-.406.2-.61.293-.057-.336-.276-.742.253-.881a1.5,1.5,0,0,0,1.165-1.581c0-.092.165-.18.253-.269.017.357.05.709.045,1.07,0,.473.095.695.6.392,1.786-1.063,3.58-2.115,5.369-3.171.491-.262.766-.34.756.44-.038,3.66,0,7.325-.035,10.983a1.44,1.44,0,0,0,.825,1.46C218.792,309.029,224.423,312.283,230.047,315.527Z",
    transform: "translate(-198.936 -259.275)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716-2",
    "data-name": "Path 716",
    d: "M188.119,189.193l-4.754,2.836c-.331-.253-.2-.536-.2-.777V169.772a1.11,1.11,0,0,1,.579-1.181q15.078-8.663,30.13-17.375a1.717,1.717,0,0,1,.369-.116c0,.338.019.676.031,1.014,0,.808-.045,1.616,0,2.42a17.884,17.884,0,0,0,.189,4.234,1.58,1.58,0,0,0-.888.364q-7.448,4.268-14.87,8.549c-2.854,1.64-5.723,3.261-8.587,4.889-.423-.343-.73-.095-.728.3a1.058,1.058,0,0,0,.395,1.033c.111,4.187.078,8.377.017,12.564-.087.09-.236.177-.253.269a1.5,1.5,0,0,1-1.165,1.581C187.843,188.451,188.067,188.857,188.119,189.193Z",
    transform: "translate(-183.138 -151.1)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703-2",
    "data-name": "Path 703",
    d: "M210.278,241.455c-.432.362-.189.893-.333,1.328a1.067,1.067,0,0,1-.395-1.033C209.548,241.351,209.855,241.1,210.278,241.455Z",
    transform: "translate(-203.309 -219.976)",
    fill: "#50b5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(-9191.737 -18623.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717-2",
    "data-name": "Path 717",
    d: "M230.047,315.527q0,3.811-.024,7.62c-2.16-1.007-4.154-2.313-6.219-3.49-5.7-3.251-11.368-6.557-17.072-9.8a1.93,1.93,0,0,1-1.134-1.983c.076-3.4.031-6.8.031-10.2,0-1.224,0-1.222-1.1-.6-.2.109-.406.2-.61.293-.057-.336-.276-.742.253-.881a1.5,1.5,0,0,0,1.165-1.581c0-.092.165-.18.253-.269.017.357.05.709.045,1.07,0,.473.095.695.6.392,1.786-1.063,3.58-2.115,5.369-3.171.491-.262.766-.34.756.44-.038,3.66,0,7.325-.035,10.983a1.44,1.44,0,0,0,.825,1.46C218.792,309.029,224.423,312.283,230.047,315.527Z",
    transform: "translate(-198.936 -259.275)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317-2",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716-3",
    "data-name": "Path 716",
    d: "M188.119,189.193l-4.754,2.836c-.331-.253-.2-.536-.2-.777V169.772a1.11,1.11,0,0,1,.579-1.181q15.078-8.663,30.13-17.375a1.717,1.717,0,0,1,.369-.116c0,.338.019.676.031,1.014,0,.808-.045,1.616,0,2.42a17.884,17.884,0,0,0,.189,4.234,1.58,1.58,0,0,0-.888.364q-7.448,4.268-14.87,8.549c-2.854,1.64-5.723,3.261-8.587,4.889-.423-.343-.73-.095-.728.3a1.058,1.058,0,0,0,.395,1.033c.111,4.187.078,8.377.017,12.564-.087.09-.236.177-.253.269a1.5,1.5,0,0,1-1.165,1.581C187.843,188.451,188.067,188.857,188.119,189.193Z",
    transform: "translate(-183.138 -151.1)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703-3",
    "data-name": "Path 703",
    d: "M210.278,241.455c-.432.362-.189.893-.333,1.328a1.067,1.067,0,0,1-.395-1.033C209.548,241.351,209.855,241.1,210.278,241.455Z",
    transform: "translate(-203.309 -219.976)",
    fill: "#50b5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(-9160.924 -18623.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717-3",
    "data-name": "Path 717",
    d: "M203.824,315.527q0,3.811.024,7.62c2.16-1.007,4.154-2.313,6.219-3.49,5.7-3.251,11.368-6.557,17.072-9.8a1.93,1.93,0,0,0,1.134-1.983c-.076-3.4-.031-6.8-.031-10.2,0-1.224,0-1.222,1.1-.6.2.109.406.2.61.293.057-.336.276-.742-.253-.881a1.5,1.5,0,0,1-1.165-1.581c0-.092-.165-.18-.253-.269-.017.357-.05.709-.045,1.07,0,.473-.095.695-.6.392-1.786-1.063-3.58-2.115-5.369-3.171-.492-.262-.766-.34-.756.44.038,3.66,0,7.325.035,10.983a1.44,1.44,0,0,1-.825,1.46C215.079,309.029,209.448,312.283,203.824,315.527Z",
    transform: "translate(-203.614 -259.275)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317-3",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716-4",
    "data-name": "Path 716",
    d: "M209.477,189.193l4.754,2.836c.331-.253.2-.536.2-.777V169.772a1.11,1.11,0,0,0-.579-1.181q-15.078-8.663-30.13-17.375a1.717,1.717,0,0,0-.369-.116c0,.338-.019.676-.031,1.014,0,.808.045,1.616,0,2.42a17.882,17.882,0,0,1-.189,4.234,1.58,1.58,0,0,1,.888.364q7.448,4.268,14.87,8.549c2.854,1.64,5.723,3.261,8.587,4.889.423-.343.73-.095.728.3a1.058,1.058,0,0,1-.395,1.033c-.111,4.187-.078,8.377-.017,12.564.087.09.236.177.253.269a1.5,1.5,0,0,0,1.165,1.581C209.754,188.451,209.529,188.857,209.477,189.193Z",
    transform: "translate(-183.138 -151.1)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703-4",
    "data-name": "Path 703",
    d: "M209.55,241.455c.432.362.189.893.333,1.328a1.067,1.067,0,0,0,.395-1.033C210.28,241.351,209.973,241.1,209.55,241.455Z",
    transform: "translate(-185.197 -219.976)",
    fill: "#50b5ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M408.728,205.606l-.118.09.092-.116Z",
    transform: "translate(-9547.069 -18816.463)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M332.588,234.174c-.361.362-.6-.031-.839-.17-1.734-.978-3.452-1.983-5.184-2.961-.253-.142-.473-.508-.858-.217a1.567,1.567,0,0,1-.182,0c.177-.265.026-.392-.2-.52q-5.293-3.025-10.574-6.054v-6.6c0-.345-.09-.723.248-.99l12.561,7.212c1.441.829,2.871,1.68,4.329,2.479a1.155,1.155,0,0,1,.669,1.167C332.541,229.736,332.572,231.955,332.588,234.174Z",
    transform: "translate(-9475.62 -18824.924)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M257.7,216.725c-.338.267-.251.5-.263.842v6.6l-8.091,4.714a2.5,2.5,0,0,0-.974.567l-.957.539c-2.363,1.342-4.707,2.689-7.068,4.017-.217.123-.553.56-.65-.118V226.82l.045-.2a.2.2,0,0,0,.13-.128,1.26,1.26,0,0,0,.69-.395l10.69-6.106c1.923-1.1,3.835-2.224,5.759-3.322A.477.477,0,0,1,257.7,216.725Z",
    transform: "translate(-9418.072 -18824.838)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M325.214,276.62a1.573,1.573,0,0,0,.182,0c.2,1.954.054,3.913.08,5.87.028,1.994,0,3.989,0,5.985,0,.364,0,.678-.392.907-3.478,1.978-6.957,4-10.439,5.995-.064.035-.221-.2-.308-.2.019-4.2.087-8.21.107-12.416.172-.092.35-.177.517-.274Z",
    transform: "translate(-9475.309 -18870.717)",
    fill: "#50b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M278.852,282.633q-.028,6.309-.059,12.616l-7.576-4.291c-.142-.08-.279-.165-.418-.25-.969-.6-2.363-.877-2.819-1.819s-.142-2.235-.144-3.377c0-2.776.026-5.553-.019-8.327,0-.794.208-.888.825-.515l.562.347.6.31.378.236a17.138,17.138,0,0,0,2.58,1.479Z",
    transform: "translate(-9439.48 -18870.594)",
    fill: "#50b5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340",
    transform: "translate(9392 18455.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M418.245,477.671a11.089,11.089,0,0,1-10.54,11.231c-5.655.108-10.667-5.092-10.7-11.091a11.055,11.055,0,0,1,10.568-11.183C413.4,466.528,418.173,471.544,418.245,477.671Zm-4.681-.084a6.186,6.186,0,0,0-5.991-6.418c-3.3.036-5.867,2.967-5.855,6.566,0,3.75,2.628,6.614,5.991,6.554S413.6,481.373,413.564,477.587Z",
    transform: "translate(-9534.438 -18883.133)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M188.36,477.841c-.136,6.126-5.056,11.219-10.7,11.071a11.117,11.117,0,0,1-10.512-11.434c.152-6.063,5.108-10.995,10.887-10.843A10.923,10.923,0,0,1,188.36,477.841Zm-4.713-.232c-.028-3.574-2.62-6.466-5.771-6.438-3.511.036-6.087,2.908-6.035,6.714.052,3.658,2.6,6.39,5.967,6.414s5.863-2.884,5.839-6.69Z",
    transform: "translate(-9396.375 -18883.135)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M468.777,476.431c0,3.9-.068,7.3.032,10.707.04,1.35-.268,1.817-1.693,1.761-2.8-.112-2.8-.024-2.8-2.776V467.082a11.678,11.678,0,0,1,3.874,2.344c3,3.243,6.035,6.458,9.126,9.769a2.546,2.546,0,0,0,.264-1.761c.036-3.1.056-6.194.02-9.294,0-.859.244-1.118,1.118-1.146,3.355-.1,3.351-.136,3.351,3.227,0,5.7-.04,11.394.024,17.093,0,1.414-.4,1.434-1.462.863a10.855,10.855,0,0,1-3.023-2.26C474.82,482.865,471.976,479.862,468.777,476.431Z",
    transform: "translate(-9574.865 -18883.334)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M523.28,466.976a10.029,10.029,0,0,1,4.05,2.42q4.05,4.393,8.143,8.73c.248.26.4.671,1.094.683v-8.874c0-3.431.108-3.5,3.63-3.119.687.076.8.351.8.931V488.47a8.577,8.577,0,0,1-4.014-2.292c-2.951-3.2-5.927-6.362-8.894-9.541-.6.375-.375.863-.375,1.258-.024,3.151-.04,6.3,0,9.453,0,.919-.1,1.366-1.222,1.37-3.227,0-3.227.068-3.231-3.2V468.769Z",
    transform: "translate(-9610.267 -18883.154)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M251.583,488.82c-.319.072-.427.1-.535.124-3.019.483-5.232-.268-6.434-3.455a13.828,13.828,0,0,0-3.395-4.461,1.909,1.909,0,0,0-1.961-.559c-.859.232-.4,1.026-.435,1.554-.052,1.877-.076,3.762,0,5.639.044,1.042-.335,1.286-1.326,1.294-3.223.024-3.219.064-3.219-3.2q0-8.627-.028-17.249c0-1.046.208-1.474,1.354-1.418,2.923.148,5.863-.232,8.786.16a6.358,6.358,0,0,1,5.671,5.036,6.045,6.045,0,0,1-3.379,6.726c-.919.491-1.046.751-.367,1.617a54.638,54.638,0,0,1,5.268,8.187ZM238.8,473.672v2c0,.467,0,.931.655.911a10.622,10.622,0,0,0,4.844-.8,2.31,2.31,0,0,0,1.222-2.652,2.084,2.084,0,0,0-2.057-1.813c-.6-.068-1.2-.164-1.805-.216-2.864-.264-2.864-.26-2.872,2.572Z",
    transform: "translate(-9436.682 -18883.398)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M115.188,477.992c0-3.147.036-6.29,0-9.437,0-1,.136-1.5,1.326-1.43,2.971.168,5.959-.248,8.926.2a6.2,6.2,0,0,1,5.483,5.192,6.271,6.271,0,0,1-3.487,6.845,11.725,11.725,0,0,1-6.118,1.066c-1.434-.04-1.773.479-1.693,1.813.112,1.869,0,3.75.044,5.627,0,.843-.232,1.11-1.118,1.134-3.347.08-3.347.12-3.347-3.2C115.188,483.18,115.184,480.588,115.188,477.992Zm4.437-4.281c0,3.107,0,3.111,3.107,2.772a9.544,9.544,0,0,0,1.8-.244,2.476,2.476,0,0,0,1.937-2.708,2.188,2.188,0,0,0-2.209-2.229c-.6-.068-1.2-.156-1.8-.208-2.832-.252-2.832-.248-2.832,2.616Z",
    transform: "translate(-9365.169 -18883.42)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M69.925,466.749a10.156,10.156,0,0,1,5.991,2.025c.883.639,1.174,1.2.028,1.957s-1.905,1.821-3.511.567a3.987,3.987,0,0,0-3.686-.152,2.128,2.128,0,0,0-1.462,1.661c-.164.895.515,1.31,1.154,1.622,1.282.635,2.62,1.166,3.914,1.781a21.012,21.012,0,0,1,2.476,1.326c3.834,2.5,3.994,6.789.335,9.585-3.127,2.4-6.438,2.237-9.8.511-.343-.176-.675-.375-1.006-.575-2.668-1.6-2.64-1.578-.4-3.594a1.3,1.3,0,0,1,1.953-.1,7.031,7.031,0,0,0,5.1,1.062,2.124,2.124,0,0,0,1.973-1.506,1.8,1.8,0,0,0-1.07-2.185c-1.43-.823-2.935-1.514-4.393-2.26-.244-.124-.491-.248-.735-.379-3.339-1.809-4.353-3.594-3.638-6.39A6.671,6.671,0,0,1,69.925,466.749Z",
    transform: "translate(-9333.413 -18883.207)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M350.432,488.893a11.007,11.007,0,0,1-10.384-7.588,11.247,11.247,0,0,1,4.233-12.481,10.36,10.36,0,0,1,12.485.3c.475.379,1.777.723.727,1.685-.779.719-.823,2.772-2.88,1.53a6.844,6.844,0,0,0-8.439.743,6.925,6.925,0,0,0-1.014,8.275,6.42,6.42,0,0,0,9.481,1.941c1.058-.759,1.55-.587,2.145.367.531.847,1.7,1.442.272,2.66A9.733,9.733,0,0,1,350.432,488.893Z",
    transform: "translate(-9499.926 -18883.283)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M293.309,479.956c0-2.544-.036-5.088.02-7.628,0-.871-.256-1.174-1.118-1.13-1.158.056-2.324-.052-3.479.032-1.042.072-1.3-.327-1.3-1.322,0-2.844-.048-2.844,2.736-2.844,3.994,0,7.964.024,11.941-.024,1.006,0,1.47.16,1.462,1.33,0,2.832.044,2.832-2.752,2.84-3.051,0-3.051,0-3.051,2.979,0,4.477-.028,8.958.02,13.435,0,.99-.236,1.326-1.286,1.326-3.2,0-3.2.044-3.2-3.2Z",
    transform: "translate(-9468.622 -18883.381)",
    fill: "#c7c7c7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.caec7db3aa6cd4a9b19c952724a02f3e.svg";
export { ForwardRef as ReactComponent };